import React from 'react';
import './LegalPages.css';

function CookiePolicyPage() {
    return (
        <div className="container legal-page">
            <h1>🍪 Cookie Policy</h1>
            <p className="effective-date"><strong>Effective Date: 28 May 2025</strong></p>
            
            <p>MythicMaps ("we", "us", "our") uses cookies and similar technologies to provide and improve our services.</p>

            <h2>1. What Are Cookies?</h2>
            <p>Cookies are small data files stored on your device. They help us remember preferences, track usage, and enhance functionality.</p>

            <h2>2. Cookies We Use</h2>
            <table className="data-table">
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Purpose</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><strong>Essential</strong></td>
                        <td>Necessary for login, session handling, and core features.</td>
                    </tr>
                    <tr>
                        <td><strong>Analytics</strong></td>
                        <td>Helps us understand user behavior using PostHog analytics.</td>
                    </tr>
                    <tr>
                        <td><strong>Session Replay</strong></td>
                        <td>Captures anonymized interactions for UX optimization via PostHog.</td>
                    </tr>
                    <tr>
                        <td><strong>Preferences</strong></td>
                        <td>Stores user settings (e.g., language, theme).</td>
                    </tr>
                </tbody>
            </table>

            <h2>3. Third-Party Cookies</h2>
            <p>We use trusted providers to help us deliver and optimize our services:</p>
            <ul>
                <li><strong>PostHog</strong> (analytics and session recording)</li>
                <li><strong>Firebase (Google)</strong> (authentication and hosting)</li>
                <li><strong>Mapbox</strong> (map rendering and geocoding)</li>
                <li><strong>Resend</strong> (transactional emails - minimal cookie usage)</li>
                <li><strong>Strava</strong> (activity data import)</li>
            </ul>
            <p>These tools may store cookies in line with their own privacy policies. All are GDPR-compliant and process only anonymized or pseudonymized data. Sensitive information like passwords and payment details are never stored in cookies.</p>

            <h2>4. Managing Cookies</h2>
            <p>You can disable cookies via your browser settings. However, some features may not function properly without essential cookies.</p>
            <p><strong>Analytics opt-out:</strong> You can disable analytics tracking by contacting us directly. If we implement advertising, you'll be able to opt out of personalized advertising through your account settings.</p>
            
            <div className="contact-section">
                <p>For more details, email us at <a href="mailto:data@mythicmaps.ai">data@mythicmaps.ai</a>.</p>
            </div>
        </div>
    );
}

export default CookiePolicyPage; 